import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';
import AiSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-settings'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_settings',
          component: AiSettings,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.AI_CORE,
          },
        },
      ],
    },
  ],
};
